import React, { useEffect } from 'react';
import { loadProgressBar } from 'axios-progress-bar';
import AuthContextProvider from './context/AuthContextProvider';
import NetworkContextProvider from './context/NetworkContextProvider';
import { MeetingContextProvider } from './context/MeetingContextProvider';
import RoutesController from './Components/routes/routesController';

function App() {
  useEffect(() => {
    loadProgressBar();
  }, []);

  return (
    <NetworkContextProvider>
      <AuthContextProvider>
        <MeetingContextProvider>
          <RoutesController />
        </MeetingContextProvider>
      </AuthContextProvider>
    </NetworkContextProvider>
  );
}

export default App;
